// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-2b2a","first-section":"first-section-325d"};